"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _api = _interopRequireDefault(require("../../api/services/api"));

var _normalizeList = require("../../utils/normalizeList");

var _package = _interopRequireDefault(require("../../../package.json"));

var MODULE_NAME = 'sdk/ui-config/services/uiConfig';

var logger = _loglevel.default.getLogger(MODULE_NAME);
/**
 *
 * @param {*} options
 * @return {Promise}
 */


var get = function get(options) {
  logger.info("".concat(MODULE_NAME, " - get called"), options);
  var params = {
    object: 'uiconfig',
    action: 'read',
    config_name: '*',
    format: 'json'
  };

  if (options.configName) {
    params.config_name = options.configName;
  }

  if (options.domain) {
    params.domain = options.domain;
  }

  if (options.user) {
    params.user = options.user;
  }

  if (options.hostname) {
    params.hostname = options.hostname;
  }

  if (options.role) {
    params.role = options.role;
  }

  if (options.reseller) {
    params.reseller = options.reseller;
  }

  logger.debug("".concat(MODULE_NAME, " - get params"), params);
  return _api.default.get(params).then(function (res) {
    if (!res.length) {
      // test if normalized requested
      if (options.normalize) {
        return (0, _normalizeList.normalizeList)('config_name', []);
      }

      return null;
    }

    var arr = res;

    if (options.returnFirst) {
      return res[0];
    }

    if (options.filter && Array.isArray(options.filter)) {
      var tmpArr = [];
      var valueFound = false;
      options.filter.forEach(function (name) {
        var confName = _package.default.config.configMapping[name] ? _package.default.config.configMapping[name].name : null;

        if (confName) {
          var value = _package.default.config.configMapping[name].default;
          var domainVal = '';
          var descriptionVal = '';
          var confObj = res.find(function (o) {
            return o.config_name === confName;
          });

          if (confObj !== undefined && confObj.config_value !== undefined) {
            if (confObj.config_value && confObj.config_value.trim()) {
              valueFound = true; // todo regex to validate theme colors

              value = confObj.config_value;
              domainVal = confObj.domain;
              descriptionVal = confObj.description;
            }
          }

          tmpArr.push({
            config_name: name,
            config_value: value,
            domain: valueFound ? domainVal : null,
            description: valueFound ? descriptionVal : null
          });
        } else {
          console.error('config mapping not found', name);
        }
      });
      arr = tmpArr;
    }

    if (options.normalize) {
      return (0, _normalizeList.normalizeList)('config_name', arr);
    }

    arr.forEach(function (config) {
      var configNameSplit = config.config_name.split('_');
      var configNameAffix = configNameSplit.pop(); // check uiConfig for a hostname affix (EG: UI_CONFIG_1_domain.com)

      var hostnameCheckExp = new RegExp(/^(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$)$/);
      var hasHostname = hostnameCheckExp.test(configNameAffix); // if this is a hostname config but the hostname doesn't match, skip it entirely

      if (hasHostname && configNameAffix !== window.location.hostname) {
        return;
      } // if this is a hostname uiConfig, apply it to the base ui config index


      var configNameBase = hasHostname ? configNameSplit.join('_') : config.config_name; // look for a config alias in pack.config, map to it if found

      var configMap; // eslint-disable-next-line no-restricted-syntax

      for (var _i = 0, _Object$entries = Object.entries(_package.default.config.configMapping); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
            configId = _Object$entries$_i[0],
            props = _Object$entries$_i[1];

        if (configNameBase === props.name) {
          configMap = props;
          configMap.id = configId;
        }
      } // if a mapping was found, apply the properties to the config


      if (configMap && configMap.id) {
        var value = configMap.default;

        if (config.config_value && config.config_value.trim()) {
          // todo regex to validate theme colors
          value = config.config_value;
        }

        arr.push({
          config_name: configMap.id,
          config_value: value,
          domain: config.domain || null,
          description: config.description || null
        });
      } else {
        arr.push({
          config_name: configNameBase,
          config_value: config.config_value,
          domain: config.domain,
          description: config.description
        });
      }
    }); // add in default values for any UIconfigs specified in package.json but not read in from API
    // eslint-disable-next-line no-restricted-syntax

    var _loop = function _loop() {
      var _Object$entries2$_i = (0, _slicedToArray2.default)(_Object$entries2[_i2], 2),
          configId = _Object$entries2$_i[0],
          props = _Object$entries2$_i[1];

      var isConfigAdded = arr.find(function (arrConf) {
        var addedByName = arrConf.config_name === props.name;
        var addedById = arrConf.config_name === configId;
        return addedByName || addedById;
      });

      if (!isConfigAdded) {
        arr.push({
          config_name: configId,
          config_value: props.default,
          domain: props.domain || null,
          description: props.description || null
        });
      }
    };

    for (var _i2 = 0, _Object$entries2 = Object.entries(_package.default.config.configMapping); _i2 < _Object$entries2.length; _i2++) {
      _loop();
    }

    return arr;
  });
};

var _default = {
  configMapping: _package.default.config.configMapping,
  get: get
};
exports.default = _default;
module.exports = exports.default;